import { css, Global, SerializedStyles } from '@emotion/react';
import { ReactNode, useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';

type Props = {
  wrapperCss?: SerializedStyles | string;
  children: ReactNode;
};

let index = 0;

const LazyLoadStyle = ({ wrapperCss, children }: Props) => {
  const [uuid, setUuid] = useState<number>();
  useEffect(() => {
    setUuid(++index);
  }, []);
  if (!uuid) {
    return null;
  }
  return (
    <LazyLoad classNamePrefix={`_${uuid}-lazyload`} offset={200}>
      {wrapperCss && (
        <Global
          styles={css`
            ._${uuid}-lazyload-wrapper {
              ${wrapperCss}
            }
          `}
        />
      )}
      {children}
    </LazyLoad>
  );
};

export default LazyLoadStyle;
